import * as React from 'react';
import { createInheritedProvider } from '@shapeable/utils';
export var ElementDimensionsContext = React.createContext({});
// export const ElementDimensionsProvider: React.FC<ElementDimensionsProviderProps> = (props) => {
//   const existingProps = React.useContext(ElementDimensionsContext) || {};
//   const { value, children } = props;
//   return <ElementDimensionsContext.Provider 
//     value={{ ...existingProps, ...(value || {}) }}
//   >{children}</ElementDimensionsContext.Provider>;
// }
export var ElementDimensionsProvider = createInheritedProvider(ElementDimensionsContext);
export var useElementDimensions = function () {
  return React.useContext(ElementDimensionsContext) || {};
};
export function useDimensionsOf(name) {
  var allValues = useElementDimensions();
  return (allValues === null || allValues === void 0 ? void 0 : allValues[name]) || {
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    x: 0,
    y: 0,
    right: 0,
    bottom: 0
  };
}
;